
import React from 'react';
import { cn } from '@/lib/utils';

interface BurgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

const BurgerButton: React.FC<BurgerButtonProps> = ({ isOpen, onClick, className }) => {
  return (
    <button
      id="burger-button"
      onClick={onClick}
      className={cn(
        "relative flex flex-col justify-center items-center w-10 h-10 rounded-full focus:outline-none transition-all",
        className
      )}
      aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
    >
      <span 
        className={cn(
          "block w-5 h-0.5 bg-gray-800 transition-all duration-300 ease-in-out",
          isOpen 
            ? "transform rotate-45 translate-y-1.5" 
            : "transform rotate-0 translate-y-0"
        )}
      />
      <span 
        className={cn(
          "block w-5 h-0.5 bg-gray-800 mt-1 transition-all duration-300 ease-in-out",
          isOpen ? "opacity-0" : "opacity-100"
        )}
      />
      <span 
        className={cn(
          "block w-5 h-0.5 bg-gray-800 mt-1 transition-all duration-300 ease-in-out",
          isOpen 
            ? "transform -rotate-45 -translate-y-1.5" 
            : "transform rotate-0 translate-y-0"
        )}
      />
    </button>
  );
};

export default BurgerButton;
